import { PageLayout } from '../layout/PageLayout'

export function PageContainer({ children, size = 'default', className = '' }) {
  return <PageLayout size={size} className={className}>{children}</PageLayout>
}
